import type { CardState } from '@shared/tabletop/types';

const DEFAULT_CARD_Z_INDEX = 10;

const getCardZIndex = (card?: CardState): number =>
  typeof card?.zIndex === 'number' ? card.zIndex : DEFAULT_CARD_Z_INDEX;

export const sortCardIdsByLayer = (
  cardIds: string[],
  cards: Record<string, CardState>
): string[] =>
  [...cardIds]
    .filter(cardId => Boolean(cards[cardId]))
    .sort((a, b) => {
      const zIndexDiff = getCardZIndex(cards[a]) - getCardZIndex(cards[b]);
      if (zIndexDiff !== 0) {
        return zIndexDiff;
      }

      return a.localeCompare(b);
    });

export const orderCardIdsForInteraction = (
  cardIds: string[],
  cards: Record<string, CardState>,
  touchedCardId: string
): string[] => {
  const ordered = sortCardIdsByLayer(cardIds, cards);
  const touchedIndex = ordered.indexOf(touchedCardId);

  if (touchedIndex === -1 || touchedIndex === ordered.length - 1) {
    return ordered;
  }

  ordered.splice(touchedIndex, 1);
  ordered.push(touchedCardId);
  return ordered;
};
